import React from 'react';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import useWindowSize from '../../../../hooks/useWindowSize';

import './LandingPageSkeleton.scss';

export function SkeletonLandingBannerSection() {
  return (
    <Skeleton className="landingBannerSkeleton" />
  );
}

export function SkeletonWhatsNewCard() {
  return (
    <div className="whatsNewCardSkeleton">
      <div className="header">
        <Skeleton width={200} height={36} />
        <div className="avatarGroup">
          <Skeleton circle width={40} height={40} />
          <Skeleton circle width={40} height={40} />
        </div>
      </div>

      <div className="cardGrid">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="cardSkeleton">
            <Skeleton width="100%" height={200} className="mainSkeleton" />
            <div className="bottomSkeleton">
              <Skeleton width="70%" height={100} className="skeletonView" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonPopularCategory() {
  return (
    <div className="skeletonPopularCategoryUI">
      <div className="popularUI">
        <Skeleton width={200} height={36} />
        <div className="avatarGroup">
          <Skeleton circle width={40} height={40} />
          <Skeleton circle width={40} height={40} />
        </div>
      </div>

      <div className="cardGrid">
        {[...Array(8)].map((_, index) => (
          <div key={index} className="cardSkeleton">
            <Skeleton circle width={100} height={100} className="bottomSkeleton" />
            <Skeleton height={20} />
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonPopularRetailer() {
  const isMobile = useWindowSize();
  return (
    <div className="popularRetailerSkeletonUI">
      <div className="popularUI">
        <Skeleton width={200} height={36} />
        <div className="avatarGroup">
          <Skeleton circle width={40} height={40} />
          <Skeleton circle width={40} height={40} />
        </div>
      </div>

      <div className="cardGrid">
        {[...Array(8)].map((_, index) => (
          <div key={index} className="cardSkeleton">
            <Skeleton width={isMobile ? 75 : 145} height={isMobile ? 50 : 100} />
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonPopularCategoryBanner() {
  const isMobile = useWindowSize();
  return (
    <div className="popularCategoryBanner">
      {/* Mobile to medium-sized screens carousel skeleton */}
      <div className="bannerSection">
        <div className="midBanner">
          {[...Array(2)].map((_, index) => (
            <div key={index} className="banner">
              <Skeleton
                width={isMobile ? 284 : 625}
                height={isMobile ? 150 : 250}
                className="borderRadius_16"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Large screens banner skeleton */}
      <div className="largeScreenBanner">
        {[...Array(2)].map((_, index) => (
          <div key={index} className="banner">
            <Skeleton
              width="100%"
              height={256}
              className="bannerInfo"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonCardSectionDesign() {
  const isMobile = useWindowSize();
  return (
    <div className="skeletonCardDesign">
      <div className="giftcardSection">
        <div className="section">
          {/* Skeleton for the GiftCardIcon and text */}
          <Skeleton width={40} height={40} />
          <Skeleton width={120} height={30} />
        </div>

        {/* Skeleton for the carousel navigation arrows */}
        <div className="carousalSection">
          <Skeleton circle width={35} height={35} />
          <Skeleton circle width={35} height={35} />
        </div>
      </div>

      {/* Carousel skeleton structure */}
      <div className="sectionStructure">
        {[...Array(6)].map((_, index) => (
          <div className="skeletonStructure" key={index}>
            {/* Skeleton for the card image */}
            <Skeleton width={isMobile ? 160 : 196} height={126} className="borderRadius_6" />

            {/* Skeleton for the card title */}
            <Skeleton width={100} height={20} className="margin_t_8" />

            {/* Skeleton for the savings amount */}
            <Skeleton width={140} height={20} className="margin_t_8" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonPreciousMetal() {
  return(
    <div className="preciousMetalSkeleton">
      <div className="sectionPrecious">
        <Skeleton width={200} height={36} />
        <div className="avatarGroup">
          <Skeleton circle width={40} height={40} />
          <Skeleton circle width={40} height={40} />
        </div>
      </div>

      <div className="preciousSkeleton">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="cardDesign">
            <Skeleton width="100%" height={200} className="mainSkeleton" />
            <div className="bottomSkeleton">
              <Skeleton width="70%" height={100} className="skeletonView" />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
};

export default function LandingPageSkeleton() {
  return (
    <div className='LandingPageSkeletonWrapper'>
      {SkeletonLandingBannerSection()}
      {SkeletonWhatsNewCard()}
      {SkeletonPopularCategory()}
      {SkeletonPopularCategoryBanner()}
      {SkeletonCardSectionDesign()}
      {SkeletonCardSectionDesign()}
      {SkeletonCardSectionDesign()}
      {SkeletonCardSectionDesign()}
      {SkeletonCardSectionDesign()}
      {SkeletonPopularRetailer()}
      {SkeletonPreciousMetal()}
    </div>
  );
};